// You can write more code here

/* START OF COMPILED CODE */

export default class LoadingSpinner extends Phaser.GameObjects.Image {

	constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
		super(scene, x ?? 0, y ?? 0, texture || "loading-spinner_png", frame);

		/* START-USER-CTR-CODE */
    this.scene.tweens
      .add({
        targets: this,
        rotation: Math.PI * 2,
        duration: 2000,
        ease: 'Linear',
        repeat: -1,
      })
      .play();

    // Ensure the spinner is loaded.
    this.scene.load.image(
      'loading-spinner_png',
      'game_assets/sprites/phaser_game/loading_screen/loading-spinner_png.png',
    );
    this.scene.load.start();
    this.scene.load.on('complete', () => {
      this.setTexture('loading-spinner_png');
      this.texture.setFilter(Phaser.Textures.LINEAR);
    });
    /* END-USER-CTR-CODE */
	}

	/* START-USER-CODE */
  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
